<script lang="ts">
	import { Briefcase, MapPin, Contact } from 'lucide-svelte';
	import * as Popover from '@/components/ui/popover';
	import type { CalendarEvent, EventColor } from '@/types/calendar';
	import { isJobEvent, isSiteVisitEvent, isLeadEvent } from '@/types/calendar';
	import { getEventColorClasses } from './calendar.utils';
	import { cn } from '@/lib/utils';
	import CalendarEventPopover from './CalendarEventPopover.svelte';

	interface Props {
		event: CalendarEvent;
		onclick?: () => void;
	}

	let { event, onclick }: Props = $props();

	const eventColor = $derived.by((): EventColor => {
		if (isJobEvent(event) && event.meta?.statusColor) {
			return event.meta.statusColor as EventColor;
		}
		if (isLeadEvent(event) && event.meta?.statusColor) {
			return event.meta.statusColor as EventColor;
		}
		if (isSiteVisitEvent(event)) {
			return 'violet';
		}
		return 'blue';
	});

	const colorClasses = $derived(getEventColorClasses(eventColor));

	const EventIcon = $derived(
		event.type === 'lead' ? Contact : event.type === 'job' ? Briefcase : MapPin,
	);

	const displayTitle = $derived.by(() => {
		if (isSiteVisitEvent(event) && event.meta?.postcode) {
			return `${event.title} - ${event.meta.postcode}`;
		}
		return event.title;
	});
</script>

<Popover.Root>
	<Popover.Trigger
		class={cn(
			'flex w-full cursor-pointer items-start gap-2 rounded-md px-2 py-1 text-left text-xs transition-colors hover:opacity-80',
			colorClasses,
		)}
		style="height: 100%;"
		{onclick}
	>
		<EventIcon class="mt-0.5 size-3 shrink-0" />
		<span class="truncate font-medium">{displayTitle}</span>
	</Popover.Trigger>
	<Popover.Content class="w-80" side="right" align="start" collisionPadding={16}>
		<CalendarEventPopover {event} />
	</Popover.Content>
</Popover.Root>